import Vue from "vue";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import Axios from "axios";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import ResponsiveHelper from "@Scripts/Infrastructure/Responsive";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account", "Newsletter"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                this.$store.dispatch("cartStore/getCart");

                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.resetCssAnimations();
        this.setHeader();
        this.setAnalytics();
        this.setFancybox();
        this.scrollTop();
        this.openNewsletterDialog();

        ResponsiveHelper.onResize();
    }

    private static resetCssAnimations() {
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setAnalytics() {
        let gaEventEditorItems = document.querySelectorAll(".editor a");
        if (gaEventEditorItems && gaEventEditorItems.length != 0) {
            for (let i = 0; i < gaEventEditorItems.length; i++) {
                gaEventEditorItems[i].addEventListener("click", function () {
                    GTagHelper.sendEvent("click", "link", gaEventEditorItems[i].getAttribute("href"));
                });
            }
        }

        let gaEventDocumentDownload = document.querySelectorAll(".documents a");
        if (gaEventDocumentDownload && gaEventDocumentDownload.length != 0) {
            for (let i = 0; i < gaEventDocumentDownload.length; i++) {
                gaEventDocumentDownload[i].addEventListener("click", function () {
                    GTagHelper.sendEvent("file_download", "product",  $(this).attr("data-galabel"));
                });
            }
        }

        $(".ga-event").on("click", function () {
            switch ($(this).attr("data-gacategory")) {
                case "Visual":
                    GTagHelper.sendEvent("click", "visual", $(this).attr("href"));
                    break;
                case "Phone":
                    GTagHelper.sendEvent("click", "phone", $(this).attr("data-galabel"));
                    break;
            }
        });
    }

    private static scrollTop() {
        var $button = $(".scrolltop"),
            scrollTrigger = 100,
            backToTop = function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > scrollTrigger) {
                    $button.attr("data-show", "");
                } else {
                    $button.removeAttr("data-show");
                }
            };

        backToTop();

        $(window).on("scroll", function () {
            backToTop();
        });

        $button.on("click", function (e) {
            e.preventDefault();
            $("html, body").animate({
                scrollTop: 0
            }, 700);
        });
    }

    private static setHeader() {
        var $header = $(".app-header");

        if ($(window).scrollTop() > 10) {
            $header.attr("data-minify", "");
        }

        $(window).scroll(function (event) {
            if ($(window).scrollTop() > 10) {
                $header.attr("data-minify", "");
            } else {
                $header.removeAttr("data-minify");
            }
        });

        $(".tools > .item[data-type='search']").on("click", function () {
            $('html, body').animate({
                scrollTop: 0
            }, 1000, function () {
                $("#SearchBox input").focus();
            });
        });
    }

    private static setFancybox() {
        (<any>$('[data-fancybox]')).fancybox({
            buttons: ["close"]
        });
    }

    private static sideMenu() {
        var $sidemenu = $(".app-page .sidemenu > .sticky");

        heightMenu();

        $(window).on("resize", function () {
            heightMenu();
        });

        function heightMenu() {
            var sidemenuh = $sidemenu.height(),
                windowh = $(window).height() - 120;

            if (sidemenuh > windowh) {
                $sidemenu.css({ "height": windowh });
            } else {
                $sidemenu.removeAttr("style");
            }
        }
    }

    private static openNewsletterDialog() {
        let ctas = document.querySelectorAll("[data-newsletterdialog]");
        for (const item of ctas) {
            item.addEventListener("click", x => {
                (<any>window).App.instances.vm.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
                GTagHelper.sendEvent("click", "newsletter", "open");
            })
        }
    }
}